
import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import styles from './AboutUs.module.scss';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import about from '../../../shared/assets/photo/about.png'
import { Button } from '../../../shared/ui/Button/Button';
import { Link } from 'react-router-dom';
import { arrowBlack } from '../../../shared/assets/svg/arrowBlack';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

export const AboutUs = () => {

    useGSAP(() => {
        gsap.to(".title__about", { "--opacity": 1,
                                    "--x": "0px",
                                    y:-10,  
                                    duration: 1, 
                                    scrollTrigger: {
                                        trigger: ".title__about"
        }});
    }, [])

    return (
        <section> 
        <div  className={styles.container}>
            <Stack 
                justifyContent = 'justifyCenter'   
                className={styles.title__content}>
                <Text type="h2" size='xl' className={`title__about ${styles.title}`}>
                    О НАС
                </Text>    
            </Stack>
                            
                <Stack
                    direction='column'
                    alignItems='alignCenter'
                    className={styles.text}
                    gap= '16'
                >   
                    <Text size="m" className={styles.par}>
                        Наша стоматологическая клиника “Итэр” работает для вас c 2015 года. “Iter” переводится с латыни как  “путь”. Mы шаг за шагом пройдем с Вами путь к красивой, здоровой улыбке и счастливой качественной жизни!
                    </Text>
                    <Text size="m" className={styles.par}>
                        Современное оборудование и технологии помогают нам комплексно подходить к лечению каждого пациента. 
                        Однако, основной задачей нашей клиники является индивидуальный подход . 
                        Наши доктора помогут вам почувствовать себя комфортно и расслабленно. 
                        Мы уделяем время тому, чтобы по-настоящему понять потребности, цели и образ жизни каждого пациента. Это дает возможность предложить решения, которые улучшат вашу улыбку, функцию зубов и помогут вести более здоровый и счастливый образ жизни.
                    </Text>
                    <Text size="m" className={styles.par}>
                        Ваша улыбка - наша забота!
                    </Text>
                </Stack>
                </div> 
                <div className={styles.about__row}>
                    <img className={styles.photo} src={about} alt="о клинике"/>
                    <Stack
                        direction='column'
                        alignItems='alignCenter'
                        className={styles.text__row}
                        gap= '16'
                >
                        <Text size="xxl" className={styles.about__text}>
                            ITER CLINIC
                        </Text>
                        <Text size="l" className={styles.about__text} >
                            <span>с 2015 года</span>
                        </Text>
                    </Stack>
                    <Button variant = 'more' className={styles.btn}>
                        <Link to= "/about" className={styles.link}>
                                {arrowBlack()}
                        </Link>
                    </Button>
                </div>


            
        </section>
    );
}